var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKcs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m11.89 16 8.044 8.199 5.105-5.106c.927-.928 2.32-.928 3.093 0a2.428 2.428 0 0 1 0 3.403l-6.652 6.807c-.927.928-2.32.928-3.248 0l-9.591-9.9v5.878c0 1.237-1.082 2.32-2.32 2.32-1.237 0-2.32-1.083-2.32-2.32V6.718c0-1.237 1.083-2.32 2.32-2.32 1.238 0 2.32 1.083 2.32 2.32v5.879l9.592-9.9c.928-.93 2.32-.93 3.249 0l6.653 6.806a2.428 2.428 0 0 1 0 3.403c-.929.928-2.32.928-3.094 0l-5.106-5.26L11.889 16zm8.044-2.32c1.237 0 2.32 1.082 2.32 2.32 0 1.238-1.083 2.32-2.32 2.32-1.238 0-2.32-1.082-2.32-2.32 0-1.238 1.082-2.32 2.32-2.32z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKcs);
export default __webpack_public_path__ + "static/media/KCS.644aa57b072c3b74fe1c9f1209dd7622.svg";
export { ForwardRef as ReactComponent };